


import TiwiMixin from '../../mixins/TiwiMixin'

export default {
  mixins: [TiwiMixin],
 
  props: {
    
    refId: {
      type: Number,
      required: true
    },
    apiEndpoint: {
      type: String,
      default: '',
      required: true,
    },

    field: {
      type: String,
      required: false,
      default: 'content',
    },
    placeholder:{
      required: false,
      type: String,
      default: 'Prego compilare il campo',

    },
    content: {
      required: false,
      type: String,
      default: '',
    },
    buttonLabel:{
      required: false,
      type: String,
      default: 'Modifica',
    },
    maxChars:{
      required: false,
      type: Number
      
    }
  },
  data() {
    return {
      current_content: '',
      editor_enabled: false,
    }
  },
  mounted: function () {
    if( this.content )
      this.current_content = this.content;
  },
  computed: {
    contentOverflow: function(){
      if( this.maxChars && ( this.current_content.length > this.maxChars ) )
        return this.current_content.length - this.maxChars;
      else  
        return 0;
    }
    
  },
  methods: {
    enableEditor: function(){
      this.original_content = this.current_content;
      this.editor_enabled = true;
      var self = this;
      this.$nextTick( function(){
        self.$refs.editor.focus();
      });
      
    },
    cancelEditor: function(){
      this.current_content = this.original_content;
      this.editor_enabled = false;
    },
    submitContent: function(){

      var self = this;
      var field_name
      var post_data = {};
      post_data[ this.field ] = this.current_content;
      this.setLoading(true);
      this.api.post( this.apiEndpoint, post_data)
        .then((response) => {
          if (response.data.success) {
            self.toast.success('Aggiornamento effettuato correttamente')
            this.editor_enabled = false;
            this.updateDeskUser();
          }
          else {
            self.toast.error(response.data.message);
            
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))

        

      
    }
  },
  watch: {

  }
}
